"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
/** HQ */
exports.vegasHQ = {
    initiative: 0,
    melee: [0, 1, 1, 1, 1, 1],
    module: [true, false, false, false, false, false],
    moduleType: types_1.Modules.Agitator,
    toughness: 20,
    type: types_1.TileTypes.HQ
};
/** Soldiers */
exports.vegasMercenary = {
    initiative: 1,
    name: types_1.VegasSoldierTiles.Mercenary,
    range: [2, 0, 0, 0, 0, 0],
    type: types_1.TileTypes.Soldier,
    toughness: 1
};
exports.vegasBodyguard = {
    initiative: 2,
    melee: [1, 1, 0, 0, 0, 1],
    name: types_1.VegasSoldierTiles.Bodyguard,
    type: types_1.TileTypes.Soldier,
    toughness: 1
};
exports.vegasGuard = {
    armor: [true, true, false, false, false, true],
    name: types_1.VegasSoldierTiles.Guard,
    type: types_1.TileTypes.Soldier,
    toughness: 2
};
exports.vegasMarksman = {
    initiative: 3,
    name: types_1.VegasSoldierTiles.Marksman,
    range: [3, 0, 0, 0, 0, 0],
    type: types_1.TileTypes.Soldier,
    toughness: 1
};
/** Modules */
exports.vegasAgitator = {
    module: [true, false, false, false, false, false],
    moduleType: types_1.Modules.Agitator,
    name: types_1.VegasModuleTiles.Agitator,
    type: types_1.TileTypes.Module,
    toughness: 1
};
exports.vegasSaboteur = {
    module: [true, true, true, true, true, true],
    moduleType: types_1.Modules.Saboteur,
    name: types_1.VegasModuleTiles.Saboteur,
    type: types_1.TileTypes.Module,
    toughness: 1
};
exports.vegasMedic = {
    module: [true, false, false, false, false, false],
    moduleType: types_1.Modules.Medic,
    name: types_1.VegasModuleTiles.Medic,
    type: types_1.TileTypes.Module,
    toughness: 1
};
exports.vegasScout = {
    module: [true, false, false, false, false, false],
    moduleType: types_1.Modules.Scout,
    name: types_1.VegasModuleTiles.Scout,
    type: types_1.TileTypes.Module,
    toughness: 1
};
/** Foundations */
exports.vegasMine = {
    foundationType: types_1.Foundations.Mine,
    name: types_1.VegasFoundationTiles.Mine,
    type: types_1.TileTypes.Foundation
};
